up.on('up:layer:opened', () => {
  document.body.classList.add('-modal-open')
})

up.on('up:layer:dismissed', () => {
  if (up.layer.isRoot()) {
    document.body.classList.remove('-modal-open')
  }
})
